import type { PushCampaign } from '../types/data';

export function pushCampaignMapper(pushCampaign): PushCampaign {
  return {
    id: pushCampaign.id,
    name: pushCampaign.name,
    status: pushCampaign.status,
    failedReason: pushCampaign?.failed_reason ?? null,
    scheduledAt: pushCampaign.scheduled_at ?? null,
    title: pushCampaign.title ?? null,
    body: pushCampaign.body ?? '',
    imageUrl: pushCampaign.image_url ?? null,
    deeplink: pushCampaign.deeplink ?? null,
    presentation: pushCampaign.presentation ?? null,
    badgeCount: pushCampaign.badge_count ?? null,
    // `?? null`, never `|| 0` — a campaign whose metrics have never synced has null counters;
    // coercing to 0 makes "not sent yet" indistinguishable from "reached nobody" (mirrors email mapper).
    sendCount: pushCampaign.send_count ?? null,
    deliveredCount: pushCampaign.delivered_count ?? null,
    failedCount: pushCampaign.failed_count ?? null,
    audiences: pushCampaign.audiences || [],
  };
}
